import clsx from 'clsx';
import React from 'react';

import { PrimaryButton, ProButton, TextButton } from '@components/Button/variants';
import LogoTIProText from '@components/Images/Rebranding/LogoTIProText';
import LogoTIText from '@components/Images/Rebranding/LogoTIText';

export type WelcomeVariant = 'desktop' | 'mobile';

export interface WelcomeContentProps {
  variant: WelcomeVariant;
  isProSubscriber: boolean;
  handleNext: () => void;
  handleClose: () => void;
}

const WelcomeContent = ({
  variant,
  isProSubscriber,
  handleNext,
  handleClose,
}: WelcomeContentProps) => {
  const Button = isProSubscriber ? ProButton : PrimaryButton;
  const isMobile = variant === 'mobile';

  const heading = (
    <h2 className="mb-8 mt-0 text-center font-suisse-screen text-headline-alt-sm font-medium text-white">
      Welcome to
    </h2>
  );

  const logo = isProSubscriber ? (
    <>
      <LogoTIProText
        className={clsx('mx-auto flex h-[30px] w-full shrink-0 text-white', {
          'max-w-[352px]': !isMobile,
          'max-w-[320px]': isMobile,
        })}
        aria-hidden
      />
      <span className="sr-only">The Information Pro</span>
    </>
  ) : (
    <>
      <LogoTIText
        className={clsx('mx-auto flex h-[30px] w-full shrink-0 text-white', {
          'max-w-[305px]': !isMobile,
          'max-w-[269px]': isMobile,
        })}
        aria-hidden
      />
      <span className="sr-only">The Information</span>
    </>
  );

  const subtitle = (
    <p className="my-0 text-center font-suisse-screen text-byline-lg text-white">
      Let&apos;s take a quick product tour
    </p>
  );

  const actions = (
    <div className={['flex w-full flex-col items-center', isMobile ? 'gap-8' : ''].join(' ')}>
      <Button as="button" size="small" className="w-full" onClick={handleNext}>
        Take me through
      </Button>
      <TextButton
        as="button"
        onClick={handleClose}
        className="mx-auto mt-8 font-suisse-intl text-button-sm text-white"
      >
        Skip
      </TextButton>
    </div>
  );

  return (
    <>
      {heading}
      <div className="flex flex-col items-center gap-24">
        {logo}
        {subtitle}
        {actions}
      </div>
    </>
  );
};

export default WelcomeContent;
